"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var clsx_1 = require("clsx");
var core_1 = require("@material-ui/core");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var financeAndInsuranceStyles_1 = require("./financeAndInsuranceStyles");
var globalTypes_1 = require("../../../../__generated__/globalTypes");
var usePlatformConfig_1 = require("../../../../common/react/usePlatformConfig");
var FinanceAndInsuranceSummary = function (_a) {
    var className = _a.className;
    var _b, _c, _d;
    var intl = react_intl_1.useIntl();
    var styles = financeAndInsuranceStyles_1.default();
    var deal = useCheckoutContext_1.default().deal;
    var insuranceIntegration = usePlatformConfig_1.default().platformConfig.platformFeatures.insuranceIntegration;
    var hasFinance = !!(((_c = (_b = deal) === null || _b === void 0 ? void 0 : _b.finance) === null || _c === void 0 ? void 0 : _c.type) === globalTypes_1.FinanceFormType.finance);
    var hasInsurance = !!((_d = deal) === null || _d === void 0 ? void 0 : _d.insurance);
    var labelId = function () {
        if (!hasFinance) {
            if (!hasInsurance) {
                return 'trans__checkout__next_step__order_now__finance_and_insurance_label';
            }
            return 'trans__checkout__next_step__finance_and_insurance__finance_label';
        }
        return 'trans__checkout__next_step__finance_and_insurance_insurance_label';
    };
    var sectionLabel = intl.formatMessage({ id: labelId() });
    if (hasFinance && ((insuranceIntegration && hasInsurance) || !insuranceIntegration)) {
        return null;
    }
    return (<core_1.Box data-test={'checkout:finance_insurance:summary'}>
      <Translation_1.default id="trans__checkout__next_step__finance_and_insurance_label1" className={clsx_1.default(className, styles.summaryLabel)} values={{ sectionLabel: sectionLabel }}/>
    </core_1.Box>);
};
exports.default = FinanceAndInsuranceSummary;
